import useFetchObjects from "../../api/useFetchObjects";

const usePartners = () => {
  return useFetchObjects(["partners"], "partners/", null, {
    refetchOnWindowFocus: false,
  });
};

export default usePartners;
